import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';
interface AccordionItemProps {
  question: string;
  answer: string;
}
export function AccordionItem({
  question,
  answer
}: AccordionItemProps) {
  const [isOpen, setIsOpen] = useState(false);
  return <div className="border-b border-divider w-full" data-id="element-244">
      <button className="w-full flex items-center justify-between py-4 text-left min-h-[52px] group" onClick={() => setIsOpen(!isOpen)} aria-expanded={isOpen} data-id="element-245">
        <span className="text-[16px] font-bold text-ink pr-4 group-hover:text-primary transition-colors" data-id="element-246">
          {question}
        </span>
        <ChevronDown className={`w-5 h-5 text-accent shrink-0 transition-transform duration-350 ease-in-out ${isOpen ? 'rotate-180' : ''}`} data-id="element-247" />
      </button>
      <div className={`overflow-hidden transition-all duration-350 ease-in-out ${isOpen ? 'max-h-[300px] opacity-100 mb-4' : 'max-h-0 opacity-0'}`} data-id="element-248">
        <p className="text-[15px] italic text-muted leading-[1.6]" data-id="element-249">{answer}</p>
      </div>
    </div>;
}